import axios from "axios";
import { storeSiteError, storeSite, loadingSite } from "../actions/siteActions";
const storageItem = "site_config";

export async function loadSiteFromStorage(store) {
    try {
        //let params = localStorage.getItem(storageItem);
        //if (!params) {
        store.dispatch(loadingSite())
        await axios
            .get(window.location.origin + "/siteparams", { headers: { Authorization: '' }, })
            .then((result) => {
                localStorage.setItem(storageItem, btoa(JSON.stringify(result.data)));
                store.dispatch(storeSite(result.data));
            })
            .catch((error) => {
                if (error.response.data && error.response.data.title)
                    store.dispatch(storeSiteError({ title: error.response.data.title, message: error.response.data.detail, status: error.response.status }));
                else
                    store.dispatch(storeSiteError({ title: error.code, message: error.message, status: error.response.status }));
            });
        //} else {
        //    store.dispatch(storeSite(JSON.parse(atob(params))));
        //}
    } catch (e) {
        store.dispatch(storeSiteError(e));
    }
}
